import * as React from 'react';
import { useSelector } from 'react-redux';
import { Dialog, DialogType } from '@fluentui/react';
import { lookupsLoadedSelector, lookupsLoadingFinishedSelector, lookupsSelector } from 'store/lookups/selector';
import { finishLoading } from 'store/lookups/actions';
import { CheckboxIcon, CheckboxCompositeIcon } from '@fluentui/react-icons';
import { mergeStyleSets } from '@fluentui/react/lib/Styling';
import { authSelector } from 'store/auth/selector';
import classnames from 'classnames';

const styles = mergeStyleSets({
    container: {
        position: 'relative',
        display: 'grid',
        gridTemplateColumns: '20px 1fr',
        gridRowGap: 5,
    },
    icon: {
        marginTop: -3,
    },
    loaded: {},
    loading: {
        animation: 'rotation 2s infinite linear',
    },
});

interface LookupIndicatorProps {
    loaded: boolean;
    label: string;
}

const LookupIndicator: React.FC<LookupIndicatorProps> = ({ loaded, label }) => {
    return (
        <>
            <div>
                {loaded ? (
                    <CheckboxCompositeIcon className={styles.icon} />
                ) : (
                    <CheckboxIcon className={classnames(styles.icon, styles.loading)} />
                )}
            </div>
            <div>{label}</div>
        </>
    );
};

export const Init: React.FC = () => {
    const auth = useSelector(authSelector);
    const lookups = useSelector(lookupsSelector);
    const lookupsLoaded = useSelector(lookupsLoadedSelector);
    const lookupsLoadingFinished = useSelector(lookupsLoadingFinishedSelector);

    if (lookupsLoaded) {
        setTimeout(finishLoading, 500);
    }

    if (lookupsLoadingFinished || !auth.isAuthenticated) {
        return null;
    }

    return (
        <Dialog
            hidden={false}
            title="Lade Daten..."
            dialogContentProps={{
                type: DialogType.normal,
            }}
            modalProps={{
                isBlocking: false,
            }}
        >
            <div className={styles.container}>
                <LookupIndicator label="Betreuer" loaded={lookups?.betreuerLoaded || false} />
                <LookupIndicator label="Textbausteine" loaded={lookups?.textbausteineLoaded || false} />
                <LookupIndicator label="Branchen" loaded={lookups?.branchenLoaded || false} />
                <LookupIndicator
                    label="Interesse für Produkte"
                    loaded={lookups?.interesseFuerProdukteLoaded || false}
                />
                <LookupIndicator label="Erweiterte Suchen" loaded={lookups?.erweiterteSuchenLoaded || false} />
                <LookupIndicator label="Länder" loaded={lookups?.laenderLoaded || false} />
                <LookupIndicator label="Skontodefinitionen" loaded={lookups?.skontodefinitionenLoaded || false} />
                <LookupIndicator label="Kontodefinitionen" loaded={lookups?.kontodefinitionenLoaded || false} />
                <LookupIndicator label="Einheiten" loaded={lookups?.einheitenLoaded || false} />
                <LookupIndicator label="Artikelgruppen" loaded={lookups?.artikelGruppenLoaded || false} />
                {/* <LookupIndicator label="Artikeldetails" loaded={lookups?.artikelDetailsLoaded || false} /> */}
                {/* <LookupIndicator label="Artikel" loaded={lookups?.artikelLoaded || false} /> */}
                <LookupIndicator label="Lager" loaded={lookups?.lagerLoaded || false} />
                <LookupIndicator label="ARA Regelungen" loaded={lookups?.araRegelungenLoaded || false} />
                <LookupIndicator label="Lieferantenformulare" loaded={lookups?.lieferantenformulareLoaded || false} />
                <LookupIndicator label="Kalkulationsblätter" loaded={lookups?.kalkulationsblaetterLoaded || false} />
                <LookupIndicator label="Artikeleigenschaften" loaded={lookups?.artikelEigenschaftenLoaded || false} />
                <LookupIndicator label="Produktgruppen" loaded={lookups?.produktgruppenLoaded || false} />
                <LookupIndicator label="Produzenten" loaded={lookups?.produzentenLoaded || false} />
                <LookupIndicator label="Maschinentypen" loaded={lookups?.maschinentypenLoaded || false} />
            </div>
        </Dialog>
    );
};
